var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useContext } from 'react';
import { useMachine } from '@xstate/react';
import trusteeMachine from './trusteeMachine';
import { i18n as i18nDefaults } from './i18n';
import { useI18n } from '../hooks/use-i18n';
import { splitObjectIntoTwo } from '../../../utils';
import { addressFields, } from '../common/interfaces';
export var TrusteeContext = createContext({
    complete: false,
    testId: '',
    cfg: {},
    current: {},
    send: function (_, __) { return ({}); },
    onCorrect: function () { },
    onRemove: Promise.resolve,
    i18n: i18nDefaults,
    addressAPI: {
        get: function (endpoint) { return Promise.resolve(endpoint); },
        limit: 50,
    },
});
export var TrusteeProvider = function (_a) {
    var trustee = _a.trustee, preValidatedData = _a.preValidatedData, complete = _a.complete, children = _a.children, onDetailsSave = _a.onDetailsSave, onContactSave = _a.onContactSave, onAddressSave = _a.onAddressSave, _b = _a.i18n, i18nRewrites = _b === void 0 ? {} : _b, rest = __rest(_a, ["trustee", "preValidatedData", "complete", "children", "onDetailsSave", "onContactSave", "onAddressSave", "i18n"]);
    var i18n = useI18n(i18nDefaults, i18nRewrites);
    var _c = splitObjectIntoTwo(trustee, addressFields), modifiedTrustee = _c[0], trusteeAddress = _c[1];
    var _d = useMachine(trusteeMachine, {
        context: {
            complete: complete,
            preValidatedData: preValidatedData,
            trustee: __assign(__assign({}, modifiedTrustee), { address: trusteeAddress }),
        },
        services: {
            onDetailsSave: function (_a) {
                var trustee = _a.trustee;
                var schemeRoleId = trustee.schemeRoleId, title = trustee.title, firstName = trustee.firstName, lastName = trustee.lastName, trusteeType = trustee.trusteeType, isProfessionalTrustee = trustee.isProfessionalTrustee;
                return onDetailsSave({
                    schemeRoleId: schemeRoleId,
                    title: title,
                    firstName: firstName,
                    lastName: lastName,
                    trusteeType: trusteeType,
                    isProfessionalTrustee: isProfessionalTrustee,
                }, trustee);
            },
            onContactSave: function (_a) {
                var trustee = _a.trustee;
                var schemeRoleId = trustee.schemeRoleId, telephoneNumber = trustee.telephoneNumber, emailAddress = trustee.emailAddress;
                return onContactSave({ schemeRoleId: schemeRoleId, telephoneNumber: telephoneNumber, emailAddress: emailAddress }, trustee);
            },
            onAddressSave: function (_a) {
                var trustee = _a.trustee;
                var schemeRoleId = trustee.schemeRoleId, address = trustee.address;
                return onAddressSave(__assign({ schemeRoleId: schemeRoleId }, address), trustee);
            },
        },
    }), current = _d[0], send = _d[1];
    var fwdValues = __assign({ current: current, send: send, i18n: i18n }, rest);
    var ui = typeof children === 'function' ? children(fwdValues) : children;
    return (React.createElement(TrusteeContext.Provider, { value: fwdValues }, ui));
};
export var useTrusteeContext = function () {
    var trusteeUtils = useContext(TrusteeContext);
    if (!trusteeUtils) {
        throw new Error("Trustee compound components cannot be rendered outside the TrusteeProvider component");
    }
    return trusteeUtils;
};
//# sourceMappingURL=context.js.map